// eslint-disable-next-line no-use-before-define
import React from 'react';
import { AlignCenter, ButtonAction, CardContainer, CardInfo, CardTitle, } from './style';
import { Tag } from '../../tag';
import { CheckIconSvg } from '../../../assets/icons/check';
import { SVGWrapper } from '../../svg-wrapper/svg-wrapper';
import { AlertIconSvg } from '../../../assets/icons/alert';
import { ProgressBar } from '../../progress-bar';
import { formatDateTime } from '../../../utils/format-date-time';
import { formatBytes } from '../../../utils/format-bytes';
import { CloudIconSvg } from '../../../assets/icons/cloud';
import { RefreshIconSvg } from '../../../assets/icons/refresh';
import { FILE_STATUS } from '@cora/download-center';
import { CloseIconSvg } from '../../../assets/icons/close';
import { COMPLETED_FILE_STATUS } from '../types';
import { useTranslation } from 'react-i18next';
const DownloadItem = ({ frontendName, name, status, percentile, createAt, timeLive, sizeBytes, updateAt, id, retry, getLink, cancel, }) => {
    const { t } = useTranslation('drawerDownload');
    const getTagByStatus = () => {
        switch (true) {
            case status === FILE_STATUS.Completed:
                return {
                    text: `${t('drawerDownload:tagCompleted')}`,
                    type: 'positive',
                    icon: React.createElement(SVGWrapper, { svg: CheckIconSvg }),
                };
            case status === FILE_STATUS.Error:
                return {
                    text: `${t('drawerDownload:tagFailed')}`,
                    type: 'negative',
                    icon: React.createElement(SVGWrapper, { svg: AlertIconSvg }),
                };
            case status === FILE_STATUS.Canceled:
                return {
                    text: `${t('drawerDownload:tagCancel')}`,
                    type: 'default',
                };
            case status === FILE_STATUS.Downloaded:
                return {
                    text: `${t('drawerDownload:tagDownloaded')}`,
                    type: 'default',
                };
        }
    };
    const getMessageByStatus = () => {
        switch (true) {
            case status === FILE_STATUS.Completed:
                return `${formatBytes(sizeBytes)} / ${t('drawerDownload:messageAvailable')} ${formatDateTime(timeLive)}`;
            case status === FILE_STATUS.Error:
                return `${t('drawerDownload:messageFailed')}`;
            case status === FILE_STATUS.Canceled:
                return `${t('drawerDownload:messageCancel')} ${formatDateTime(updateAt)}`;
            case status === FILE_STATUS.Downloaded:
                return `${t('drawerDownload:messageDownload')} ${formatDateTime(updateAt)}`;
            case status === FILE_STATUS.Processing:
                return `${t('drawerDownload:messageRequested')} ${formatDateTime(createAt)}`;
            default:
                break;
        }
    };
    return (React.createElement(CardContainer, null,
        React.createElement("div", { className: "first-column" },
            React.createElement(CardTitle, null,
                frontendName,
                " | ",
                name),
            React.createElement(CardInfo, null, getMessageByStatus())),
        React.createElement("div", { className: `column ${status === FILE_STATUS.Processing ? 'center' : 'end'}` }, status === FILE_STATUS.Processing ? (React.createElement(AlignCenter, null,
            React.createElement(ProgressBar, { percentile: percentile }),
            React.createElement(ButtonAction, { className: "tooltip", onClick: () => cancel(id) },
                React.createElement("span", { className: "tooltiptext" }, t('drawerDownload:tooltipDownloadCancel')),
                React.createElement(SVGWrapper, { svg: CloseIconSvg })))) : (React.createElement(AlignCenter, null,
            COMPLETED_FILE_STATUS[status] && React.createElement(Tag, { ...getTagByStatus() }),
            status === FILE_STATUS.Completed && (React.createElement(ButtonAction, { onClick: () => getLink(id) },
                React.createElement("label", null, t('drawerDownload:btnDownload')),
                React.createElement(SVGWrapper, { svg: CloudIconSvg }))),
            status === FILE_STATUS.Requested && (React.createElement(Tag, { text: `${t('drawerDownload:tagRequested')}`, type: "default" })),
            status === FILE_STATUS.Error && (React.createElement(ButtonAction, { className: "tooltip", onClick: () => retry(id) },
                React.createElement("span", { className: "tooltiptext" }, t('drawerDownload:tooltipTryAgain')),
                React.createElement(SVGWrapper, { svg: RefreshIconSvg }))))))));
};
export { DownloadItem };
//# sourceMappingURL=index.js.map